import React from "react";
import {bindActionCreators} from "redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import {connect} from "react-redux";
import GameComponent from "game/app/components/game/game-component";
import QuestionForm from "../../../common/question-form";
import CreativeTaskForm from "../../../common/creative-task-form";
import {submitCreativeTask} from "game/app/actions/creative-tasks-actions";
import Loading from "game/app/components/layout/loading";
import {Link} from "react-router-dom";

class Questions extends GameComponent {

    sendAnswer = (values, form) => {
        this.props.sendInput(this.getInstanceId(), { type: 'answer', answer: values });
    };

    submitCreativeTask = (task) => {
        return (values, form) => {
            this.props.submitCreativeTask(this.getInstanceId(), task.id, values)
        }
    };

    render() {
        if (this.props.knowledgeQuestions.loading) {
            return (<Loading/>);
        }

        let node = 'Nodes::Round01Node';

        let answers = this.getInstance().answers;
        let current_round = this.isCurrentNodeType(node);
        let current_node_id = this.getNodeId(node);
        let instance_id = this.getInstanceId();

        let roundCompleted = this.getInstanceProperty('ROUND_1_COMPLETED');

        let creative_tasks = this.props.creativeTasks.list
            .filter((task) => task.node === node)
            .map((task) => {
                return (<CreativeTaskForm key={task.id} resource={task} active={!roundCompleted} handleSubmit={this.submitCreativeTask(task)}/>);
            });

        let questions = this.props.knowledgeQuestions.list
            .filter((question) => question.properties.category === 'specific' && question.properties['game_node_id'] === current_node_id)
            .map((question) => {
                let answer = answers.find((answer) => answer.luduengine_knowledge_question_id === question.id);
                return (<QuestionForm key={question.id} className='question' question={question} answer={answer} handleSubmit={this.sendAnswer} active={current_round} instanceId={instance_id} />)
            });

        let profile_finished = this.getInstanceProperty('PROFILE_FINISHED');

        return (
            <div className='container'>
                <div className='row'>
                    <div className={this.mainContainerClass}>
                        <h1 className='page-title-minor separate-bottom'>Úkoly</h1>
                        <p className='label'>Specifické úkoly</p>
                        <div className='separate-bottom'>
                            { !profile_finished &&
                            <div>
                                <p>Po dokončení profilu možná budete muset reagovat na specifické události.</p>
                            </div>
                            }
                            { profile_finished && questions.length === 0 &&
                            <div>
                                <p>Specifické události nenastaly</p>
                            </div>
                            }
                            { profile_finished && questions.length > 0 &&
                            <div>
                                <p>Nastaly následující specifické události</p>
                                { questions }
                            </div>
                            }
                        </div>
                        <div className='separate-bottom'>
                            <p className='label'>Kreativní úkoly</p>
                            { creative_tasks }
                        </div>
                        <div className='separate-bottom text-center'>
                            <Link className='btn btn-primary' to={`/game/${this.getInstanceId()}/round-1/rodina`}>Profil domácnosti</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


function mapStateToProps(state, ownProps) {
    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
        creativeTasks: state.creativeTasks
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput,
        submitCreativeTask: submitCreativeTask
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Questions);
